export function isMobile() {
  let mb = null;
  if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
  navigator.userAgent.match(/Opera Mini/i) || navigator.userAgent.match(/IEMobile/i)) {
    mb = true;
  } else {
    mb = false;
  }
  return mb;
}


export default {
  isMobile,
};



// WEBPACK FOOTER //
// ./src/services/detectDevice.js